import { Button } from "./button";
import { Heading } from "./heading";
import { Text } from "./text";
export const components = { Button, Heading, Text };
